<template>
  <div class="link-field-container" @click="handleClick(link)"></div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    link: {
      type: String,
      required: true,
    },
  },
  setup() {
    const handleClick = (link: string) => {
      if (link) {
        window.open(link.includes('http') ? link : `//${link}`);
      }
    };

    return {
      handleClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.link-field-container {
  background: transparent;
  height: 100%;
  width: 100%;
  cursor: pointer;
}
</style>
